<template>
  <table class="table table-sm color">
    <caption class="caption table-caption">Policy Information</caption>
    <tbody>
      <tr>
        <th class="text-left font-weight-normal">Liability Limit</th>
        <td class="text-right">{{liabilityLimitPct}}</td>
        <td class="text-right">{{liabilityLimit}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">Retention Limit</th>
        <td class="text-right">{{retentionLimitPct}}</td>
        <td class="text-right">{{retentionLimit}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">Initial Collateral</th>
        <td class="text-right">{{initialCollateralPct}}</td>
        <td class="text-right">{{initialCollateral}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">Initial Premium</th>
        <td class="text-right">{{initialPremiumPct}}</td>
        <td class="text-right">{{initialPremium}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">Ownership</th>
        <td class="text-right">{{ownershipPct}}</td>
        <td class="text-right">{{ownership}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["liabilityLimit", "liabilityLimitPct", "retentionLimit", "retentionLimitPct", "initialCollateral", "initialCollateralPct",
    "initialPremium", "initialPremiumPct", "ownership", "ownershipPct"]
}
</script>

